import { render, staticRenderFns } from "./AlertTemplatesSelect.vue?vue&type=template&id=6f07b59d&"
import script from "./AlertTemplatesSelect.vue?vue&type=script&lang=js&"
export * from "./AlertTemplatesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports